import React, { useMemo } from 'react';
import * as Styles from '../NewHomeLayoutHandler/NewHomeLayoutHandler.styles';
import { ESSENTIAL_TOOLS_IDS } from './EssentialTools.enum';
import { sortEssentialToolCards } from './essentialToolsSort';
import emailBr from '@/pages/Home/media/essential-tools/email-br.png';
import linkInBioBr from '@/pages/Home/media/essential-tools/link-in-bio-br.png';
import gatorProtectBr from '@/pages/Home/media/essential-tools/gator-protect-br.png';
import domainsBr from '@/pages/Home/media/essential-tools/domains-br.png';
import siteBuilderBr from '@/pages/Home/media/essential-tools/site-builder-br.png';
import siteLockBr from '@/pages/Home/media/essential-tools/site-lock-br.png';
import { CardProduct } from '../CardProduct';

const IMAGES = {
  [ESSENTIAL_TOOLS_IDS.EMAIL]: emailBr,
  [ESSENTIAL_TOOLS_IDS.LINK_IN_BIO]: linkInBioBr,
  [ESSENTIAL_TOOLS_IDS.GATOR_PROTECT]: gatorProtectBr,
  [ESSENTIAL_TOOLS_IDS.DOMAIN]: domainsBr,
  [ESSENTIAL_TOOLS_IDS.SITE_BUILDER]: siteBuilderBr,
  [ESSENTIAL_TOOLS_IDS.SITE_LOCK]: siteLockBr,
};

const EssentialTools = ({ locale, cardsActions, activationById = {} }) => {
  const { cards } = locale;

  const sortedCards = useMemo(
    () => sortEssentialToolCards(Object.values(cards), cardsActions, activationById),
    [cards, cardsActions, activationById],
  );

  return (
    <Styles.WhiteCardContent data-testid="essential-tools">
      <Styles.WhiteCardHeader>
        <Styles.Title>{locale.title}</Styles.Title>
        <Styles.Subtitle>{locale.subtitle}</Styles.Subtitle>
      </Styles.WhiteCardHeader>

      <Styles.WrapperCardsProducts>
        {sortedCards.map(card => (
          <CardProduct
            key={`essential-tool-card-${card.id}`}
            image={IMAGES[card.id]}
            title={card.title}
            description={card.description}
            buttonPrimaryLabel={cardsActions[card.id]?.cta?.primary?.label}
            buttonPrimaryOnClick={cardsActions[card.id]?.cta?.primary?.onClick}
            buttonPrimaryVariant={cardsActions[card.id]?.cta?.primary?.variant || 'primary'}
            shouldShowButtonPrimary={cardsActions[card.id]?.cta?.primary?.shouldShow}
            buttonSecondaryLabel={cardsActions[card.id]?.cta?.secondary?.label}
            buttonSecondaryOnClick={cardsActions[card.id]?.cta?.secondary?.onClick}
            buttonSecondaryVariant={cardsActions[card.id]?.cta?.secondary?.variant || 'secondary'}
            shouldShowButtonSecondary={cardsActions[card.id]?.cta?.secondary?.shouldShow}
            tagLabel={cards[card.id]?.tag?.label}
            tagVariant={cards[card.id]?.tag?.variant}
          />
        ))}
      </Styles.WrapperCardsProducts>
    </Styles.WhiteCardContent>
  );
};

export default EssentialTools;
